import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'transaction/:transactionId',
    loadComponent: () =>
      import('./features/components/transaction/transaction').then((c) => c.Transaction),
  },
  {
    path: 'transaction/user/:transactionId',
    loadComponent: () =>
      import('./features/components/verify-transaction/verify-transaction').then(
        (c) => c.VerifyTransaction
      ),
  },
  {
    path: 'pending',
    loadComponent: () =>
      import('./features/components/payment-pending/payment-pending').then((c) => c.PaymentPending),
  },
  {
    path: '**',
    loadComponent: () => import('./shared/components/not-found/not-found').then((c) => c.NotFound),
  },
];
